module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow-last-10952ff381d44888b732431522b276bc.png";